import * as React from 'react';
import { SVGProps } from 'react';

const SvgRedArrowCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="16" cy="16" r="16" fill="var(--color2, #CE1126)" />
    <path
      d="M12 16h8M16 12l4 4-4 4"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgRedArrowCircleIcon;
